export default __webpack_public_path__ + "static/media/faTruck.89c402cc.png";